import { gql } from "@apollo/client";

// Deferred companion to SearchAssets: everything the asset list needs that the
// search index does not carry, fetched separately and merged into the
// already-rendered rows by asset location id. The @include flags limit the
// request to what is actually shown:
// - withActions: installation, IoT connection and contract for the actions
//   column's "Create IoT device" entry (CRM hop)
// - withPath: the ancestor path for the location column (icon, path tooltip)
//   and the trash badge behind the serial number — the index only knows the
//   direct parent's title. The table always requests it; the export only for
//   the location column
// - withNetworkInfo: networkInformation is slow (~15-20s per page with
//   connected assets) and backs the SIM columns
export const SearchAssetsDeferred = gql`
    query SearchAssetsDeferred (
        $filter: SearchAssetFilter
        $query: SearchAssetQuery
        $pagination: Pagination
        $sort: Sort
        $withActions: Boolean!
        $withPath: Boolean!
        $withNetworkInfo: Boolean!
    ) {
        searchAssets(
            filter: $filter
            query: $query
        ) {
            total
            searchAssetResults (pagination: $pagination, sort: $sort) {
                assetLocation {
                    id
                    installedBaseNode @include(if: $withActions) {
                        id
                    }
                    installedBaseNode @include(if: $withPath) {
                        id
                        nodeType {
                            id
                            key
                        }
                        pathNodes {
                            id
                            title
                            nodeType {
                                id
                                key
                            }
                        }
                    }
                    owner @include(if: $withActions) {
                        id
                        contract {
                            id
                            contractDurationTo
                        }
                    }
                    iotConnection @include(if: $withActions) {
                        id
                    }
                    iotConnection @include(if: $withNetworkInfo) {
                        id
                        gateway {
                            id
                            # Upstream gateway for the gateway indicator in the SIM status column.
                            gateway {
                                id
                                imei
                            }
                        }
                        networkInformation {
                            signalStrength
                            currentStandard
                            networkProvider
                        }
                    }
                }
            }
        }
    }
`;
